import { BaseService } from './baseService';

class AnnouncementsService extends BaseService<
	Announcement,
	'announcementID',
	'announcements'
> {
	constructor() {
		super('announcementID', 'announcement', 'announcements');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new AnnouncementsService();
